/**
 * Se muestra después del primer login con Google si el usuario no tiene ciudad
 * configurada. El usuario puede saltarla pero le pedimos los datos para que
 * aproveche la proximidad geográfica en matches y mercado.
 */
import { useState, type FormEvent } from "react";
import { Icon } from "../lib/Icon";
import { useAuth } from "../contexts/AuthContext";
import { useToast } from "../lib/toast";
import { ApiError } from "../api/client";
import { LocationFields } from "../lib/LocationFields";

interface Props {
  onDone: () => void;
}

export function CompleteProfileScreen({ onDone }: Props) {
  const { user, updateMe } = useAuth();
  const toast = useToast();
  const [country, setCountry] = useState(user?.country || "Colombia");
  const [city, setCity] = useState(user?.city || "");
  const [region, setRegion] = useState(user?.region || "");
  const [saving, setSaving] = useState(false);

  if (!user) return null;

  const submit = async (e: FormEvent) => {
    e.preventDefault();
    if (!city.trim()) {
      toast("La ciudad es importante para los matches");
      return;
    }
    setSaving(true);
    try {
      await updateMe({ country, city: city.trim(), region: region.trim() || undefined });
      toast("¡Perfil completado!");
      onDone();
    } catch (e) {
      toast(`Error: ${e instanceof ApiError ? e.message : e}`);
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="onb-stage">
      <div className="onb-card">
        <div style={{ display: "flex", justifyContent: "center", marginBottom: 16 }}>
          <div style={{ width: 72, height: 72, borderRadius: "50%", background: "var(--primary-soft)", color: "var(--primary)", display: "grid", placeItems: "center" }}>
            <Icon name="user" size={36} />
          </div>
        </div>

        <h2 style={{ fontFamily: "var(--font-display)", fontSize: 28, fontWeight: 800, textAlign: "center", margin: "0 0 8px" }}>
          ¡Bienvenido, {user.name.split(" ")[0]}!
        </h2>
        <p style={{ textAlign: "center", color: "var(--fg-muted)", margin: "0 0 24px" }}>
          Cuéntanos dónde estás. Así te conectamos con coleccionistas cerca de ti para intercambios en persona o por envío local.
        </p>

        <form onSubmit={submit} className="col" style={{ gap: 14 }}>
          <LocationFields
            country={country}
            city={city}
            region={region}
            onChange={({ country: c, city: ci, region: r }) => {
              setCountry(c); setCity(ci); setRegion(r);
            }}
            disabled={saving}
          />

          <div style={{ display: "flex", gap: 8, marginTop: 16 }}>
            <button type="button" className="btn btn-ghost" onClick={onDone} disabled={saving}>
              Saltar por ahora
            </button>
            <div style={{ flex: 1 }} />
            <button type="submit" className="btn btn-primary btn-lg" disabled={saving}>
              {saving ? "Guardando…" : "Continuar"} <Icon name="arrow" size={16} />
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
